var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"comments"},_vm._l((_vm.mutableComments),function(comment,index){return _c('app-comment',{key:index,attrs:{"comment":comment}})}),1),_vm._v(" "),(this.$can('create', 'Comment'))?_c('app-comment-form',{attrs:{"post_id":_vm.myPostId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }